var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-final-modal',_vm._g(_vm._b({attrs:{"classes":"modal--container","content-class":"modal--content qr-modal"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var close = ref.close;
return [_c('img',{attrs:{"src":_vm.qrCodeUrl}})]}}])},'vue-final-modal',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }